export const Common = {
  Choose: 'Choose',
  No: 'No',
  Yes: 'Yes',
};
